import {
    EmailShareButton, EmailIcon,
    FacebookShareButton, FacebookIcon,
    TelegramShareButton, TelegramIcon,
    TwitterShareButton, TwitterIcon,
    WhatsappShareButton, WhatsappIcon,
} from 'react-share';

export default function SharePopup({ shareOpened, setShareOpened, lang, url, title, hashTag }) {
    return (
        <div
            className="overview-share-content"
            onMouseEnter={(e) => e.stopPropagation()}
            style={{
                transform: shareOpened ? 'translate(0px, 0px)' : '',
                opacity: shareOpened ? 1 : 0,
                flexDirection: lang === 'en' ? 'row-reverse' : 'row',
            }}
        >
            <div className="overview-share-content-icons">
                <FacebookShareButton url={url} quote={title} hashtag={hashTag}>
                    <FacebookIcon size={36} />
                </FacebookShareButton>
                <TwitterShareButton url={url} quote={title} hashtag={hashTag}>
                    <TwitterIcon size={36} />
                </TwitterShareButton>
                <WhatsappShareButton url={url} quote={title} hashtag={hashTag}>
                    <WhatsappIcon size={36} />
                </WhatsappShareButton>
                <TelegramShareButton url={url} quote={title} hashtag={hashTag}>
                    <TelegramIcon size={36} />
                </TelegramShareButton>
                <EmailShareButton url={url} quote={title} hashtag={hashTag}>
                    <EmailIcon size={36} />
                </EmailShareButton>
            </div>
        </div>
    );
}